// extracted by mini-css-extract-plugin
export default {"container":"OtpCode_container__+4xl8","inputStyle":"OtpCode_inputStyle__wKv-T"};